import './article-title.scss'
